import type { ArTryOnModelFields } from '@/api/types/tryon';

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
}

function asModelUrl(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() ? value.trim() : undefined;
}

/** 新模型优先；新字段缺失、为空或格式异常时兼容旧 GLB 字段。 */
export function getArTryOnModelUrl(product: unknown): string | undefined {
  if (!isRecord(product)) return undefined;

  const modelFiles = product.ar_tryon_model_files;
  const newModelUrl = isRecord(modelFiles) ? asModelUrl(modelFiles.glb_model) : undefined;

  return newModelUrl ?? asModelUrl(product.glb_model);
}

/** 不同 SKU 只使用关联色自己的模型；同 SKU 的精简数据保留主商品字段。 */
export function getVariantArTryOnModelFields(
  product: unknown,
  variant?: unknown,
): ArTryOnModelFields {
  const base = isRecord(product) ? product : {};
  const selected = isRecord(variant) ? variant : base;
  const isSameSku =
    typeof base.shop_sku === 'string' &&
    base.shop_sku.length > 0 &&
    base.shop_sku === selected.shop_sku;
  const glbModel =
    isSameSku && selected.glb_model === undefined ? base.glb_model : selected.glb_model;
  const modelFiles =
    isSameSku && selected.ar_tryon_model_files === undefined
      ? base.ar_tryon_model_files
      : selected.ar_tryon_model_files;
  return {
    glb_model: glbModel === null ? null : asModelUrl(glbModel),
    ar_tryon_model_files:
      modelFiles === null
        ? null
        : isRecord(modelFiles)
          ? { glb_model: modelFiles.glb_model === null ? null : asModelUrl(modelFiles.glb_model) }
          : undefined,
  };
}
